<template>
  <div>
    <template v-if="contractsFilter && contractsFilter.length">
      <div
        v-for="contract in contractsFilter"
        :key="contract.id"
        class="documents-table__wrap"
      >
        <simplebar>
          <div class="documents-table">
            <div class="documents-table__header">
              <div
                class="documents-table__col documents-table__col--number-contract"
              >
                {{ $t("event.documents.contractNumberAndDate") }}
              </div>

              <div
                class="documents-table__col documents-table__col--sum-contract"
              >
                {{ $t("event.documents.sum") }}
              </div>

              <div class="documents-table__col documents-table__col--paid">
                {{ $t("event.documents.paid") }}
              </div>
            </div>
            <div class="item-documents-table item-documents-table--main">
              <!-- Desktop version -->
              <div class="documents-table__row documents-table__row--desktop">
                <div
                  class="documents-table__col documents-table__col--number-contract"
                >
                  {{
                    contract.is_rent
                      ? $t("event.documents.contractNumberAndDateContent", {
                          number: contract.number,
                          date: formatDate(contract.contract_date)
                        })
                      : "---"
                  }}
                </div>

                <div
                  class="documents-table__col documents-table__col--sum-contract"
                >
                  {{ contract.amount | format }}&nbsp;{{
                    getCurrency(contract.currency)
                  }}
                </div>

                <div class="documents-table__col documents-table__col--paid">
                  {{ contract.amount_paid | format }}&nbsp;{{
                    getCurrency(contract.currency)
                  }}
                </div>
              </div>

              <!-- Mobile version -->
              <div class="documents-table__row documents-table__row--mobile">
                <div class="documents-table__mobile-content">
                  <div class="documents-table__mobile-left">
                    <div class="documents-table__mobile-contract">
                      {{
                        contract.is_rent
                          ? $t("event.documents.contractNumberAndDateContent", {
                              number: contract.number,
                              date: formatDate(contract.contract_date)
                            })
                          : "---"
                      }}
                    </div>
                    <div class="documents-table__mobile-amounts">
                      <div class="documents-table__mobile-amount">
                        <span class="documents-table__mobile-label"
                          >{{ $t("event.documents.sum") }}:</span
                        >
                        {{ contract.amount | format }}&nbsp;{{
                          getCurrency(contract.currency)
                        }}
                      </div>
                      <div class="documents-table__mobile-amount">
                        <span class="documents-table__mobile-label"
                          >{{ $t("event.documents.paid") }}:</span
                        >
                        {{ contract.amount_paid | format }}&nbsp;{{
                          getCurrency(contract.currency)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template
              v-if="getInvoices(contract) && getInvoices(contract).length"
            >
              <div
                v-for="invoice in getInvoices(contract)"
                :key="invoice.id"
                class="item-documents-table"
              >
                <div class="documents-table__row">
                  <div
                    class="documents-table__col documents-table__col--number-invoice"
                  >
                    <div
                      class="documents-table__btn-accordion"
                      @click="setShowDetail(contract.id, invoice.id)"
                    >
                      <icon
                        name="select-arrow"
                        :class="{
                          rotated: checkShowDetail(contract.id, invoice.id)
                        }"
                      />

                      {{
                        $t("event.documents.invoiceDateNumber", {
                          number: invoice.number,
                          date: formatDate(invoice.document_date)
                        })
                      }}
                    </div>
                  </div>

                  <div class="documents-table__col documents-table__col--sum">
                    {{ invoice.amount | format }}&nbsp;{{
                      getCurrency(contract.currency)
                    }}
                  </div>

                  <div
                    class="documents-table__col documents-table__col--download"
                  >
                    <div
                      v-if="invoice.file"
                      class="documents-table__icon-download"
                      @click="
                        downloadFile(
                          invoice.id,
                          $t('event.documents.invoiceDateNumber', {
                            number: invoice.number,
                            date: formatDate(invoice.document_date)
                          })
                        )
                      "
                    >
                      <Tooltip
                        :label="$t('event.documents.downloadFileShort')"
                        position="left"
                      >
                        <icon name="download-transparent" />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    invoice.contents &&
                      invoice.contents.length &&
                      checkShowDetail(contract.id, invoice.id)
                  "
                  class="item-documents-table__footer"
                >
                  <div class="item-documents-table__footer-list">
                    <template v-for="(content, key) in invoice.contents">
                      <div :key="content.id" class="item-footer">
                        <div class="item-footer__col item-footer__col--info">
                          <div class="title">
                            {{ key + 1 }}.
                            {{
                              currLocale === "en"
                                ? content.name_eng
                                : content.name_rus
                            }}
                          </div>

                          <div class="count">
                            <nobr>
                              {{ content.quantity }}
                              {{
                                currLocale === "en"
                                  ? content.measure_unit_eng
                                  : content.measure_unit_rus
                              }}
                            </nobr>
                          </div>
                        </div>
                        <div class="item-footer__col item-footer__col--hall">
                          {{
                            currLocale === "en"
                              ? content.rental_object_eng
                              : content.rental_object_rus
                          }}
                        </div>
                        <div class="item-footer__col item-footer__col--sum">
                          {{ content.amount | format }}&nbsp;{{
                            getCurrency(contract.currency)
                          }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </simplebar>
      </div>
    </template>

    <Loader v-if="showLoader" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import apiParticipant from "@/api/participant";
import { Loader, Tooltip } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalDocumentsContentIssuedInvoices",
  components: {
    Tooltip,
    Loader
  },

  data() {
    return {
      showLoader: false,
      showDetailState: [],
      contractUpdateLoading: null
    };
  },

  computed: {
    ...mapState("documents", ["contracts", "currenciesComparisonTable"]),
    ...mapState("event", ["event"]),
    ...mapGetters("event", ["eventId", "exhibition"]),

    contractsFilter() {
      if (!this.contracts.length) return [];

      return this.contracts;
    },

    currLocale() {
      return i18n.locale;
    }
  },
  methods: {
    setShowDetail(contractId, invoiceId) {
      if (
        this.showDetailState.find(
          item => item.contractId === contractId && item.invoiceId === invoiceId
        )
      ) {
        this.showDetailState = this.showDetailState.filter(
          item => item.contractId !== contractId && item.invoiceId !== invoiceId
        );
      } else {
        this.showDetailState.push({
          contractId: contractId,
          invoiceId: invoiceId
        });
      }
    },

    checkShowDetail(contractId, invoiceId) {
      return this.showDetailState.find(
        item => item.contractId === contractId && item.invoiceId === invoiceId
      );
    },

    formatDate(date) {
      if (!date) return "";

      return i18n.locale === "ru"
        ? moment(date).format("DD.MM.YYYY")
        : moment(date).format("MM.DD.YYYY");
    },

    getCurrency(currency) {
      if (
        !currency ||
        !this.currenciesComparisonTable ||
        (this.currenciesComparisonTable &&
          !this.currenciesComparisonTable.length)
      ) {
        return "₽";
      }

      const result = this.currenciesComparisonTable.find(
        el => el.code === currency
      );
      if (result) {
        return result.symbol;
      }

      return "₽";
    },

    getInvoices(contract) {
      return contract.documents.filter(document => document.type === "invoice");
    },

    async downloadFile(invoiceId, invoiceName) {
      try {
        this.showLoader = true;

        const response = await apiParticipant.downloadDocument(
          this.eventId,
          invoiceId
        );
        let blob = new Blob([response], {
          type: "application/pdf"
        });
        const url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = `${invoiceName}.pdf`;
        link.click();
      } finally {
        this.showLoader = false;
      }
    }
  },
  filters: {
    format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ")
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.documents-info {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 44px;
  box-sizing: border-box;

  .svg-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    color: #cdced0;

    @include respond-down(md) {
      width: 16px;
      height: 16px;
    }
  }
  &__text {
    flex: 1;
    font-size: 13px;
    line-height: 20px;
    color: #000000;

    @include respond-down(md) {
      font-size: 9px;
      line-height: 12px;
    }
  }
}

.documents-table {
  min-width: 340px;
  overflow-x: auto;

  @include respond-down(md) {
    margin-bottom: 8px;
    min-width: auto;
    overflow-x: visible;
  }
  &__wrap {
    margin-bottom: 40px;

    @include respond-down(md) {
      margin-bottom: 22px;
    }
  }
  &__header {
    font-size: 14px;
    margin-bottom: 0;

    @include respond-down(lg) {
      font-size: 12px;
      line-height: 16px;
    }

    @include respond-down(md) {
      display: none;
    }
  }
  &__row {
    margin-bottom: 0;

    @include respond-down(md) {
      padding-left: 5px;
      padding-right: 5px;
      padding-bottom: 0;
      line-height: 10px;
    }
    .documents-table__col {
      @include respond-down(md) {
        padding-bottom: 17px;
      }
    }
  }
  &__icon-download {
    position: relative;
  }
  &__col {
    @include respond-down(md) {
      padding-left: 3px;
      padding-right: 3px;
    }
    &--number-contract {
      width: 51%;
      padding-left: 26px;
      text-align: left;

      @include respond-down(lg) {
        padding-left: 16px;
      }
      @include respond-down(md) {
        width: 45%;
        padding-left: 3px;
      }
      .documents-table__title-mobile {
        @include respond-down(md) {
          text-align: left;
        }
      }
    }
    &--sum-contract,
    &--sum {
      width: 14%;

      @include respond-down(md) {
        width: 18%;
      }
    }
    &--paid {
      width: 16%;

      @include respond-down(md) {
        width: 18%;
      }
    }
    &--edo {
      width: 14%;
      text-align: center;

      @include respond-down(md) {
        width: 15%;
      }
    }
    &--number-invoice {
      width: 70%;
      padding-left: 26px;
      text-align: left;

      @include respond-down(lg) {
        padding-left: 16px;
      }
      @include respond-down(md) {
        width: 64%;
        padding-left: 3px;
      }
    }
    &--download {
      width: 16%;

      @include respond-down(md) {
        width: 18%;
      }
    }
  }
  &__btn-accordion {
    position: relative;
    display: inline-block;
    vertical-align: top;
    max-width: 100%;
    padding-left: 40px;
    user-select: none;
    cursor: pointer;

    @include respond-down(lg) {
      padding-left: 25px;
    }
    @include respond-down(md) {
      padding-left: 20px;
    }
    .svg-icon {
      display: inline-block;
      vertical-align: top;
      position: absolute;
      top: 3px;
      left: 0;
      width: 16px;
      height: 16px;
      fill: #0070d2;

      @include respond-down(lg) {
        width: 13px;
        height: 13px;
      }
      @include respond-down(md) {
        width: 12px;
        height: 12px;
        top: -1px;
      }
      &.rotated {
        transform: rotate(180deg);
      }
    }
  }
}

.item-documents-table {
  margin-bottom: 0;
  border-top: none;

  &__footer {
    .item-footer {
      position: relative;

      &:after {
        @include respond-down(lg) {
          left: 16px;
          right: 16px;
        }
        @include respond-down(md) {
          left: 8px;
          right: 8px;
        }
      }
      &__col {
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
        text-align: center;

        &--info {
          width: 51%;
          padding-left: 26px;
          text-align: left;

          @include respond-down(lg) {
            padding-left: 16px;
          }
          @include respond-down(md) {
            display: block;
            width: 45%;
            padding-left: 8px;
          }
          .title {
            width: 76%;

            @include respond-down(md) {
              display: inline;
              width: auto;
              flex: none;
            }
          }
          .count {
            width: 24%;
            text-align: center;

            @include respond-down(md) {
              display: block;
              width: auto;
              padding: 3px 0 0;
              text-align: left;
            }
          }
        }
        &--hall {
          width: 19%;
          text-align: center;
        }
        &--sum {
          width: 14%;

          @include respond-down(md) {
            width: 18%;
          }
        }
      }
    }
  }
  &__footer-list {
    @include respond-down(md) {
      margin-top: 3px;
    }
  }
}

// Mobile-specific styles for documents table
.documents-table {
  &__row {
    &--desktop {
      @include respond-down(md) {
        display: none;
      }
    }

    &--mobile {
      display: none;

      @include respond-down(md) {
        display: block;
        padding: 16px 8px;
        border-bottom: 1px solid #dcdcdc;
      }
    }
  }

  &__mobile-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }

  &__mobile-left {
    flex: 1;
    min-width: 0;
  }

  &__mobile-contract {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.3;
    color: #000;
    margin-bottom: 8px;
    word-break: break-word;
  }

  &__mobile-amounts {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__mobile-amount {
    font-size: 13px;
    line-height: 1.3;
    color: #000;
  }

  &__mobile-label {
    color: #666;
    font-weight: 400;
    margin-right: 4px;
  }

  &__mobile-right {
    flex-shrink: 0;
  }

  &__mobile-edo {
    display: flex;
    align-items: center;
  }
}
</style>
